import { apiHelper } from '@/utils'
import { API } from '@/constants'

export const documentService = {
    getAllDocuments, 
};

const MODULE = {
    DOCUMENT: 'rnd-documents',
}

// const API_URL = API.BASE_URL.replace('@serviceName', 'AI') + '/v1'
const API_URL = API.BASE_URL + '/v1'


export function getAllDocuments(filter) {
   
    const requestOptions = {params: {}}

    let array = filter.searchArray
    array.forEach((word, index) => {
      if(word != null || word != '')
      {
        var searchParam = `search_words[${index}]`
        requestOptions.params[searchParam] = word
      }
    })
    
    return apiHelper(API_URL).get(`/${MODULE.DOCUMENT}`, requestOptions)
}